export const PayrollHelper = {
    updatePaymentValue: (value, index) => {
        let payroll = JSON.parse(sessionStorage.payroll);
        payroll.payments[index].value = value;
        sessionStorage.setItem('payroll', JSON.stringify(payroll));
    }
}